<template lang="pug">
form.FormAdditionalDocumentsDownload.additional-doc-form
  BaseSpinner(:value="model.$loading || profile.$loading")
  .additional-doc-form__fields
    BaseFormGroup(
      name="email",
      label="Email Address",
      :model="model",
    )
    BaseFormGroup(
      name="first_name",
      label="First Name",
      :model="model",
    )
    BaseFormGroup(
      name="last_name",
      label="Last Name",
      :model="model",
    )
    BaseFormGroup(
      name="phone",
      label="Phone Number",
      :model="model",
      type="tel"
    )
    BaseNotificationInline(:value="model.__error__")
  BaseButton(
    type="submit"
    color="primary"
    block
    target="_blank"
    @click.prevent="send"
    tabindex="1"
  ) Submit
</template>

<script>
import { mapGetters } from 'vuex';
import { ADDITIONAL_DOCUMENTS_URL } from 'Config/constans';
import { FormBeforeSendError } from 'Classes';
import AdditionalDocumentsDownloadModel from 'Models/AdditionalDocumentsDownloadModel';
import formHandlingMixin from 'Mixins/formHandlingMixin';
import formHubspotMixin from 'Mixins/formHubspotMixin';
import BaseNotificationInline from 'Components/Base/BaseNotificationInline';
import BaseButton from 'Components/Base/BaseButton';

export default {
  name: 'FormAdditionalDocumentsDownload',
  components: {
    BaseNotificationInline,
    BaseButton,
  },
  mixins: [formHandlingMixin, formHubspotMixin],
  data() {
    return {
      model: new AdditionalDocumentsDownloadModel(),
      ADDITIONAL_DOCUMENTS_URL,
    };
  },
  computed: {
    ...mapGetters('profile', [
      'profile',
    ]),
  },
  watch: {
    profile: {
      handler: 'copyFromProfile',
      immediate: true,
    },
  },
  methods: {
    async send() {
      try {
        await this.$_form_send();
        window.open(this.ADDITIONAL_DOCUMENTS_URL, '_blank');
        this.$emit('success');
      } catch (error) {
        if (!(error instanceof FormBeforeSendError)) throw error;
      }
    },
    copyFromProfile() {
      if (Object.keys(this.profile).length) {
        this.model.$setAll(this.profile);
      } else {
        this.model.$reset();
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.additional-doc-form
  background: $white
  border: 1px solid $support_lightgray
  box-shadow: 0 2px 15px 0 rgba(0,0,0,0.05)
  border-radius: 2px
  border-bottom-left-radius: 5px
  border-bottom-right-radius: 5px
  &__fields
    padding: 40px 96px 25px
    @media screen and (max-width: 576px)
      padding: 10px
</style>
